import {
	CalendarOutlined,
	CameraOutlined,
	MinusSquareOutlined,
	NumberOutlined,
	UserOutlined,
} from "@ant-design/icons";
import React, { Component } from "react";
import stc from "string-to-color";

const BookingHeader = (orderDetails) => {
	return (
		<div
			className="booking_header"
			style={{
				borderLeft: `8px solid ${stc(orderDetails?.data?.companyCode)}`,
			}}
		>
			<div className="header_cell">
				<div className="header_cell_icon_div">
					<CameraOutlined className="header_cell_icon" />
				</div>
				<div>
					<h5>Client</h5>
					<span className="font-size-m">
						{orderDetails?.data?.companyCode}
					</span>
				</div>
			</div>
			<div className="header_cell">
				<div className="header_cell_icon_div">
					<MinusSquareOutlined className="header_cell_icon" />
				</div>
				<div>
					<h5>Order Name</h5>
					<span className="font-size-m">
						{orderDetails?.data?.name}
					</span>
				</div>
			</div>
			<div className="header_cell">
				<div className="header_cell_icon_div">
					<NumberOutlined className="header_cell_icon" />
				</div>
				<div>
					<h5>Batch Number</h5>
					<span className="font-size-m">
						{orderDetails?.data?.batchNo}
					</span>
				</div>
			</div>
			<div className="header_cell">
				<div className="header_cell_icon_div">
					<CalendarOutlined className="header_cell_icon" />
				</div>
				<div>
					<h5>Booking Date</h5>

					<span className="font-size-m">
						{new Date(
							orderDetails?.data?.createdAt
						).toLocaleDateString("en-US", {
							day: "numeric",
							month: "short",
							year: "numeric",
						})}
					</span>
				</div>
			</div>
			<div className="header_cell">
				<div className="header_cell_icon_div">
					<UserOutlined className="header_cell_icon" />
				</div>
				<div>
					<h5>Created By</h5>
					<span className="font-size-m">
						{orderDetails?.data?.createdBy?.name}
					</span>
				</div>
			</div>
		</div>
	);
};

export default BookingHeader;
